import { convertToObjById } from "helpers/convertToObject";
import { orderArrayV2 } from "helpers/orderArray";

export const types = {
  // STATIONS
  LOAD_STATIONS: "LOAD_STATIONS",
  SET_STATIONS: "SET_STATIONS",
  ERROR_STATIONS: "ERROR_STATIONS",
  SET_STATIONS_MENU: "SET_STATIONS_MENU",
  LOAD_CUSTOMER: "LOAD_CUSTOMER",
  LOAD_CUSTOMERS: "LOAD_CUSTOMERS",
  SET_CUSTOMERS: "SET_CUSTOMERS",
  SET_CUSTOMER_FETCH: "SET_CUSTOMER_FETCH",
  ERROR_CUSTOMERS: "ERROR_CUSTOMERS",
  CLEAR_CUSTOMERS: "CLEAR_CUSTOMERS",
  // CUSTOMER
  SET_CUSTOMER: "SET_CUSTOMER",
  // MENU DATA
  LOAD_MENU_DATA: "LOAD_MENU_DATA",
  SET_MENU_DATA: "SET_MENU_DATA",
  ERROR_MENU_DATA: "ERROR_MENU_DATA",
  // UNITS
  CLEAR_UNITS: "CLEAR_UNITS",
  // CUSTOMER ORDERS
  LOAD_ORDERS: "LOAD_ORDERS",
  SET_ORDERS: "SET_ORDERS",
  ERROR_ORDERS: "ERROR_ORDERS",

  // NEW CUSTOMER
  SEND_CUSTOMER: "SEND_CUSTOMER",
  SUCCESS_CUSTOMER: "SUCCESS_CUSTOMER",
  ERROR_CUSTOMER: "ERROR_CUSTOMER",
  // NEW ACCOUNT
  SEND_ACCOUNT: "SEND_ACCOUNT",
  SUCCESS_ACCOUNT: "SUCCESS_ACCOUNT",
  ERROR_ACCOUNT: "ERROR_ACCOUNT",
  // NEW ORDER
  SEND_ORDER: "SEND_ORDER",
  SUCCESS_ORDER: "SUCCESS_ORDER",
  ERROR_ORDER: "ERROR_ORDER",
  // ACCOUNT FORM
  CHANGE_ACCOUNT: "CHANGE_ACCOUNT",
  // SERVICE FORM
  CHANGE_ACCOUNT_SERVICE: "CHANGE_ACCOUNT_SERVICE",
  SUSCRIPTION_FORM: "SUSCRIPTION_FORM",
  GET_SUSCRIPTION_CYCLES: "GET_SUSCRIPTION_CYCLES",
  CREATE_CYCLE: "CREATE_CYCLE",
  EDIT_CYCLE: "EDIT_CYCLE",
  DELETE_CYCLE: "DELETE_CYCLE",
  SET_SUSCRIPTION: "SET_SUSCRIPTION",
  IS_EDIT_SUSCRIPTION: "IS_EDIT_SUSCRIPTION",
  SET_PRODUCT_SUSCRIPTION: "SET_DATA_SUSCRIPTION",
  RESET_SUSCRIPTION: "RESET_SUSCRIPTION",
  CRM_SNACKBAR: "CRM_SNACKBAR",
  CRM_RESET_SNACKBAR: "CRM_RESET_SNACKBAR",

  GET_CUSTOMER_CONDITIONS: "GET_CUSTOMER_CONDITIONS",
  CRM_ADD_CONDITION: "CRM_ADD_CONDITION",
  CRM_SAVE_CONDITION: "CRM_SAVE_CONDITION",
  EDIT_CUSTOMER_CONDITION: "EDIT_CUSTOMER_CONDITION",
  DELETE_CUSTOMER_CONDITION: "DELETE_CUSTOMER_CONDITION",
  
  GET_CONTRACTS: "GET_CONTRACTS",
  NEW_CONTRACT: "NEW_CONTRACT",
};

const INITIAL_STATE = {
  // customers
  customers: [],
  customer: {},
  phone: "",
  accounts: [],
  products: [],
  customerConditions: {
    origin: '',
    agreedVolume: '',
    conditions: []
  },
  contracts: [],
  conditionsToSave: [],
  schedules: [],
  accountsMap: null,
  isLoadingServices: false,
  services: [],
  isLoading: false,
  isLoadingData: false,
  units: [],
  stations: [],
  stationsMap: null,
  // new customer
  isLoadingCustomer: false,
  // new account
  isLoadingAccount: false,
  // new order
  isLoadingOrder: false,
  // account Form
  accountForm: {
    selectedAccount: null,
  },
  // service Form
  serviceForm: {
    selectedAccount: null,
  },
  isCustomer: null,
  suscriptions: [],
  suscriptionForm: {
    account: '',
    idCycleType: '',
    description: '',
    quantity: 0,
    idProduct: '',
    schedule: ''
  },
  suscriptionCycles: [],
  suscriptionMode: false,
  crmSnackbar: {
    isActive: false,
    color: '',
    message: ''
  },
  isEditCycle: false,
  conditions: []
};

const buildSubscriptions = (accounts) =>
  accounts.flatMap(acc => {
    if (acc?.cycles && Array.isArray(acc.cycles) && acc.cycles.length > 0) {
      return acc.cycles.map(cycle => ({ ...acc, cycle }));
    } else if (acc?.cycle) {
      return [acc];
    }
    return [];
  });

export const crmReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.LOAD_STATIONS:
      return {
        ...state,
        isLoadingData: true,
        stations: [],
        stationsMap: null,
      };
      case types.SET_STATIONS:
        return {
          ...state,
          ...payload,
        isLoadingData: false,
      };
    case types.ERROR_STATIONS:
      return {
        ...state,
        isLoadingData: false,
      };
    case types.CLEAR_UNITS: {
      return {
        ...state,
        units: [],
        products: [],
      };
    }
    //Customer
    case types.SET_CUSTOMER:
      return {
        ...state,
        customer: payload.customer,
        accounts: payload.accounts,
        accountsMap: payload.accountsMap,
        phone: payload.phone,
        suscriptions: buildSubscriptions(payload.customer.accounts)
      };

    // CUSTOMERS
    case types.LOAD_CUSTOMERS:
      return {
        ...state,
        isLoading: true,
        customers: [],
        customer: null,
        accounts: [],
        phone: "",
      };

    case types.SET_CUSTOMERS:
      return {
        ...state,
        customers: payload.customers,
        phone: payload.phone,
        isLoading: false,
        isCustomer: payload.customers.length > 0 ? true : false,
      };
    case types.SET_CUSTOMER_FETCH: 
      return {
        ...state,
        customer: payload.customer,
        accounts: payload.customer.accounts,
        accountsMap: payload.customer.accounts,
        phone: payload.phone,
        isLoading: false,
        suscriptions: buildSubscriptions(payload.customer.accounts)
      };
    case types.ERROR_CUSTOMERS:
      return {
        ...state,
        isLoading: false,
      };
    case types.LOAD_MENU_DATA:
      return {
        ...state,
        isLoadingData: true,
        units: [],
        products: [],
        schedules: [],
      };
    case types.SET_MENU_DATA:
      return {
        ...state,
        ...payload,
        isLoadingData: false,
      };
    case types.ERROR_MENU_DATA:
      return {
        ...state,
        isLoadingData: false,
      };
    case types.LOAD_ORDERS:
      return {
        ...state,
        isLoadingServices: true,
        services: [],
      };
    case types.SET_ORDERS:
      return {
        ...state,
        services: payload.services,
        isLoadingServices: false,
      };
    case types.ERROR_ORDERS:
      return {
        ...state,
        isLoadingServices: false,
      };
    // new customer
    case types.SEND_CUSTOMER:
      return {
        ...state,
        isLoadingCustomer: true,
      };
    case types.SUCCESS_CUSTOMER:
      return {
        ...state,
        customer: payload.customer,
        isLoadingCustomer: false,
      };
    case types.ERROR_CUSTOMER:
      return {
        ...state,
        isLoadingCustomer: false,
      };
    // new account
    case types.SEND_ACCOUNT:
      return {
        ...state,
        serviceForm: {
          ...state.serviceForm,
          selectedAccount: payload?.body ? payload.body : payload.selectedAccount,
        },
        isLoadingAccount: true,
      };
    case types.SUCCESS_ACCOUNT:
      let newAccounts = [];
      let newAccountsMap = {};
      if (payload.isEdit) {
        newAccounts = [...state.accounts];
        const indexRow = newAccounts.findIndex(
          (account) => account.id === payload.account.id
        );
        if (indexRow !== -1) {
          newAccounts[indexRow] = payload.account;
          newAccountsMap[payload.account.id] = payload.account;
        }
      } else {
        newAccounts = [...state.accounts, payload.account];
        newAccountsMap = {
          ...state.accountsMap,
          [payload.account.id]: payload.account,
        };
      }
      return {
        ...state,
        isLoadingAccount: false,
        accounts: newAccounts,
        accountsMap: newAccountsMap,
      };
    case types.ERROR_ACCOUNT:
      return {
        ...state,
        isLoadingAccount: false,
      };
    // new order
    case types.SEND_ORDER:
      return {
        ...state,
        isLoadingOrder: true,
      };
    case types.SUCCESS_ORDER: {
      const newServices = [...payload.service, ...state.services];
      return {
        ...state,
        isLoadingOrder: false,
        services: newServices,
      };
    }
    case types.ERROR_ORDER:
      return {
        ...state,
        isLoadingOrder: false,
      };
    // account form
    case types.CHANGE_ACCOUNT:
      return {
        ...state,
        accountForm: {
          ...state.accountForm,
          selectedAccount: payload.selectedAccount,
        },
      };
    // service form
    case types.CHANGE_ACCOUNT_SERVICE:
      return {
        ...state,
        serviceForm: {
          ...state.serviceForm,
          selectedAccount: {
            ...payload.selectedAccount,
            value: payload.selectedAccount.id,
            label: payload.selectedAccount.alias
          },
        },
      };
    case types.CLEAR_CUSTOMERS:
      return {
        ...state,
        ...INITIAL_STATE,
      };

    case types.SUSCRIPTION_FORM:
      return {
        ...state,
        suscriptionForm: {
          ...state.suscriptionForm,
          ...payload
        }

      }
    case types.GET_SUSCRIPTION_CYCLES:
      const addingCycleLabel = convertToObjById(
        payload.map((cl, idx) => {
          return {
            ...cl,
            label: cl.type,
            value: cl.id,
            idx: idx + 1
          }
        }).slice(0, payload.length - 1)
      )
      return {
        ...state,
        suscriptionCycles: addingCycleLabel,
      }
    case types.SET_SUSCRIPTION:
      return {
        ...state,
        suscriptionMode: true
      }
    
      case types.CREATE_CYCLE:
      const accountToUpdate = (state.customer.accounts || []).find(acc => acc.id === payload.idAccount);
      const newCycle = { ...accountToUpdate, cycle: payload };
      
      return {
        ...state,
        customer: {
          ...state.customer,
          accounts: (state.customer.accounts || []).map(account => {
            if (account.id === payload.idAccount) {
              return {
                ...account,
                cycles: [...(account.cycles || []), payload]
              };
            }
            return account;
          })
        },
        suscriptions: [...state.suscriptions, newCycle],
        crmSnackbar: {
          isActive: true,
          color: 'success',
          message: 'Ciclo creado con éxito'
        }
      }

    case types.EDIT_CYCLE:
      return {
        ...state,
        customer: {
          ...state.customer,
          accounts: (state.customer.accounts || []).map(account => {
            if (account.cycles && Array.isArray(account.cycles)) {
              return {
                ...account,
                cycles: account.cycles.map(cycle => 
                  cycle.id === payload.id ? payload : cycle
                )
              };
            }
            return account;
          })
        },
        suscriptions: state.suscriptions.map(sus => {
          return sus.cycle?.id === payload.id ? {
            ...sus,
            cycle: payload
          } : sus
        }),
      }
    case types.DELETE_CYCLE: 
      return {
        ...state,
        customer: {
          ...state.customer,
          accounts: (state.customer.accounts || []).map(account => {
            if (account.cycles && Array.isArray(account.cycles)) {
              return {
                ...account,
                cycles: account.cycles.filter(cycle => cycle.id !== payload)
              };
            }
            return account;
          })
        },
        suscriptions: state.suscriptions.filter(sus => sus.cycle?.id !== payload),
      }
    case types.IS_EDIT_SUSCRIPTION: 
      return {
        ...state,
        isEditCycle: payload
      }

    case types.RESET_SUSCRIPTION:
      return {
        ...state,
        suscription: {
          accountSuscription: {},
          product: {},
          quantity: {},
          userText: ""
        },
        suscriptionMode: false,
      }
      
    case types.SET_PRODUCT_SUSCRIPTION:
      return {
        ...state,
        suscription: {
          ...state.suscription,
          accountSuscription: payload.accountSuscription,
          product: payload.product,
          price: payload.price,
          userText: payload.userText
        }
      }

    case types.CRM_SNACKBAR:
      return {
        ...state,
        crmSnackbar: {
          isActive: true,
          ...payload
        }
      }

    case types.CRM_RESET_SNACKBAR:
      return {
        ...state,
        crmSnackbar: {
          isActive: false,
          color: '',
          message: ''
        }
      }
    case types.GET_CUSTOMER_CONDITIONS: 
    const { origin, volume, conditions } = payload
    const nConditions = conditions.map(cond => {
      return cond.quantity === 'N/A'|| cond.quantity === 'SI' || cond.quantity === 'NO' ? { ...cond, blockInput: true } : {...cond, blockInput: false}
    })
      return {
        ...state,
        customerConditions: {
          origin, 
          agreedVolume: volume, 
          conditions: nConditions
        }
      }

    case types.CRM_ADD_CONDITION:

      return {
        ...state,
        customerConditions: {
          ...state.customerConditions,
          origin: payload.origin,
          agreedVolume: payload.agreedVolume,
          conditions: [
            payload.conditions,
            ...state.customerConditions?.conditions,
          ]
        },
        conditionsToSave: [
          payload.conditions,
          ...state.conditionsToSave
        ]
      }
    case types.CRM_SAVE_CONDITION: 
    const newConditions = [...state.customerConditions.conditions, ...payload.conditions]
    return {
      ...state,
      customerConditions: {
        ...state.customerConditions,
        origin: payload.origin,
        agreedVolume: payload.volume,
        conditions: newConditions
      }
  }
  //     return state
    case types.EDIT_CUSTOMER_CONDITION:
      const tempConditions = state.customerConditions.conditions
      const conditionsEdited = tempConditions.map(cond => {
        return cond.id === payload.id ? {...cond,...payload} : cond
      })
      return {
        ...state,
        customerConditions: {
          ...state.customerConditions,
          conditions: conditionsEdited
        }
      }
    case types.DELETE_CUSTOMER_CONDITION:
      return {
        ...state,
        customerConditions: {
          ...state.customerConditions,
          conditions: state.customerConditions.conditions.filter(cond => cond.id !== payload)
        }
      }
    case types.GET_CONTRACTS:
      const orderPayload = orderArrayV2(payload, 'date', true)
      return {
        ...state,
        contracts: orderPayload
      }

    case types.NEW_CONTRACT:
      const newContracts = state.contracts.unshift(payload)
      return {
        ...state,
        contracts: newContracts
      }
    
    default:
      return state;
  }
};
